import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}career`;

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    };
};

export const careerService = {
    getPaginate: async (queryString) => {
        try {
            const response = await axios.get(`${API_URL_WEB}/paginate?${queryString}`, getAuthHeader());
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Gagal mengambil data lowongan',
                status: error.response?.status,
            };
        }
    },

    getById: async (id) => {
        try {
            const response = await axios.get(`${API_URL_WEB}/${id}`, getAuthHeader());
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: error.response?.data?.message };
        }
    },

    create: async (data) => {
        try {
            const response = await axios.post(API_URL_WEB, data, getAuthHeader());
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: error.response?.data?.message || 'Gagal membuat lowongan' };
        }
    },

    update: async (id, data) => {
        try {
            const response = await axios.patch(`${API_URL_WEB}/${id}`, data, getAuthHeader());
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: error.response?.data?.message || 'Gagal memperbarui lowongan' };
        }
    },

    delete: async (id) => {
        try {
            await axios.delete(`${API_URL_WEB}/${id}`, getAuthHeader());
            return { success: true };
        } catch (error) {
            return { success: false, error: error.response?.data?.message || 'Gagal menghapus lowongan' };
        }
    }
};

export default careerService;